import { get } from 'lodash-es';
import { useEffect, useState } from 'react';

import { applicationsActions } from '@store/applications/applications.slice';

import { useCurrentAccount } from '@hook/account/use-current-account.hook';
import { useDeleteApplicationMutation, useLazyLoadApplicationsQuery } from '@hook/application/application.hooks';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useStoreSelector } from '@hook/store/store.hooks';

export const useOverviewPage = () => {
  const { current } = useCurrentAccount();
  const applications = useStoreSelector((state) => state.applications.data);
  const [applicationId, setId] = useState('false');
  const [isOpen, setOpen] = useState(false);
  const account = get(current, 'id');

  const showModal = () => setOpen(true);
  const closeModal = () => {
    setId('');
    setOpen(false);
  };

  const { action: reloadApplications } = useLazyQuery(
    useLazyLoadApplicationsQuery(),
    applicationsActions,
    applicationsActions.setData,
  );

  const { action: actionDelete, state } = useMutation(useDeleteApplicationMutation(), applicationsActions);

  const handleDelete = () => {
    void actionDelete({ id: applicationId, account });
  };

  useEffect(() => {
    if (state.isSuccess) {
      reloadApplications(undefined);
      setId('');
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.isSuccess, reloadApplications]);

  return {
    applications: Object.values(applications),
    handleDelete,
    isOpen,
    showModal,
    closeModal,
    setId,
    isLoading: state.isLoading,
  };
};
